import { FC, InputHTMLAttributes } from 'react';

interface FloatingLabelInputProps
  extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
}

const FloatingLabelInput: FC<FloatingLabelInputProps> = ({
  label,
  type = 'text',
  value,
  onChange,
  name,
  onBlur,
  ...rest
}) => {
  return (
    <div className="relative h-14 w-full bg-transparent">
      <input
        autoComplete="none"
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder=" "
        {...rest}
        className={`peer absolute left-0 top-0 w-full border border-gray-300 rounded-md px-3 pt-5 pb-2 text-base text-gray-900 focus:outline-none focus:ring-0 focus:border-blue-500 bg-transparent z-30`}
      />
      <label
        className={`absolute left-3 top-1 text-gray-500 text-xs transform transition-all duration-200 
          peer-placeholder-shown:top-5 peer-placeholder-shown:text-xs peer-placeholder-shown:text-gray-400 
          peer-focus:top-1 peer-focus:text-blue-500 z-10`}
        htmlFor={name}
      >
        {label}
      </label>
    </div>
  );
};

export default FloatingLabelInput;
